// src/components/GoogleMapsWrapper.tsx
import React from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

interface Props {
  children: React.ReactNode;
}

const GoogleMapsWrapper: React.FC<Props> = ({ children }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-maps-script',
    googleMapsApiKey: 'AIzaSyCkpt0UTpGCtRER3R4GsdZIJ3zNiHtQm00',
    libraries: ['places'], // always include all needed libraries
  });

  if (!isLoaded) return <div>Loading Google Maps...</div>;

  return <>{children}</>;
};

export default GoogleMapsWrapper;
